export async function toggleFavoriteProduct(
  productId,
  isFavorite,
  token,
  productData = null
) {
  // API call commented out - using cache only for now
  // Uncomment below to enable API calls:
  /*
  const baseUrl = "https://erp-elsalab.odoo.com";
  const url = `${baseUrl}/api/cs/product/toggle-favorite`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "text/plain; charset=UTF-8",
      },
      body: JSON.stringify({
        access_token: token,
        product_id: productId,
        favorite: isFavorite,
      }),
    });

    if (!res.ok) {
      let message = "";
      try {
        const j = await res.json();
        message = j?.message || j?.error || j?.detail || "";
      } catch (_) {
        message = await res.text().catch(() => "");
      }
      throw new Error(
        message || `Toggle favorite failed with status ${res.status}`
      );
    }
  } catch (e) {
    const msg = e?.message?.toLowerCase().includes("failed to fetch")
      ? "Network error or CORS blocked"
      : e?.message || "Toggle favorite failed";
    throw new Error(msg);
  }
  */

  // Only save to localStorage cache, skip API call
  if (productData) {
    try {
      const raw = localStorage.getItem("wishlist_items");
      const items = raw ? JSON.parse(raw) : [];

      if (isFavorite) {
        // Add to wishlist
        const exists = items.some((x) => x.id === String(productId));
        if (!exists) {
          items.push({
            id: String(productId),
            name: productData.title || productData.name || "",
            title: productData.title || productData.name || "",
            price: productData.price ?? null,
            list_price: productData.list_price ?? null,
            image:
              productData.image ||
              productData.image_url_1920 ||
              productData.image_url ||
              (productId
                ? `https://erp-elsalab.odoo.com/web/image/${productId}`
                : ""),
            image_url_1920: productData.image_url_1920 || null,
            image_url: productData.image_url || null,
            availability: productData.availability || "In stock",
            brand: productData.brand || productData.att_model_name || "",
            colors:
              productData.colors ||
              (productData.att_color ? [productData.att_color] : []),
            sizes:
              productData.sizes ||
              (productData.att_size && productData.att_size !== "-"
                ? [productData.att_size]
                : []),
            att_size: productData.att_size || null,
            att_color: productData.att_color || null,
            att_specifications: productData.att_specifications || null,
            description: productData.description || null,
            categ_name: productData.categ_name || null,
            current_offer: productData.current_offer || null,
            package_quantity: productData.package_quantity || 1,
            stock: productData.stock || [],
            category: productData.category || null,
            is_favorite: true,
          });
          localStorage.setItem("wishlist_items", JSON.stringify(items));
          // Dispatch custom event to notify WishlistContext
          window.dispatchEvent(new Event("wishlist-updated"));
        }
      } else {
        // Remove from wishlist
        const filtered = items.filter((x) => x.id !== String(productId));
        localStorage.setItem("wishlist_items", JSON.stringify(filtered));
        // Dispatch custom event to notify WishlistContext
        window.dispatchEvent(new Event("wishlist-updated"));
      }
    } catch (e) {
      console.error("Failed to update localStorage:", e);
      throw new Error("Failed to update favorites cache");
    }
  }

  // Return a promise that resolves immediately (no API call)
  return Promise.resolve({ success: true });
}
